import { useCallback } from 'react'

import { StoreonModule } from 'storeon'
import { useStoreon } from 'storeon/react'

import isArray from 'lodash/isArray'
import isBoolean from 'lodash/isBoolean'
import isEqual from 'lodash/isEqual'
import pickBy from 'lodash/pickBy'

import { ProjectRecordFragment } from 'GraphQL/DatoCMS/TypedDocuments'

const KEY = 'ui'

interface StateValues {
  gdprAccepted: boolean
  projects: ProjectRecordFragment[]
}

const INITIAL_STATE = {
  gdprAccepted: false,
  projects: [],
}

export interface State {
  [KEY]: StateValues
}

export interface Events {
  updateUi: Partial<StateValues>
  clear: void
}

const uiModule: StoreonModule<State, Events> = store => {
  store.on('@init', () => ({
    [KEY]: INITIAL_STATE,
  }))

  store.on('updateUi', (state, variables) => {
    const values = pickBy(variables, (value, name) => {
      switch (name) {
        case 'gdprAccepted':
          return isBoolean(value)
        case 'projects':
          return isArray(value)
        default:
          break
      }
    })

    const nextUi = { ...state[KEY], ...values }

    if (isEqual(nextUi, state[KEY])) return null

    return { [KEY]: nextUi }
  })
}

function useUI() {
  const { ui: uiState, dispatch } = useStoreon<State, Events>(KEY)

  const setProjects = useCallback(
    (nextValue: any[]) => {
      dispatch('updateUi', { projects: nextValue })
    },
    [dispatch],
  )

  return { ui: uiState, setProjects }
}

export default uiModule

export { INITIAL_STATE, KEY, useUI }
